const WonderType = {
  ANCIENT_WORLD: 1,
  GREAT_EMPIRE: 2,
  STORIES_AND_MYTHS: 3
};

export default WonderType;
